/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BoothOptionTemplateDto } from '../../models/booth-option-template-dto';
import { CreateBoothOptionTemplateDto } from '../../models/create-booth-option-template-dto';

export interface BoothOptionTemplateControllerCreateV1$Params {
      body: CreateBoothOptionTemplateDto
}

export function boothOptionTemplateControllerCreateV1(http: HttpClient, rootUrl: string, params: BoothOptionTemplateControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothOptionTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, boothOptionTemplateControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BoothOptionTemplateDto>;
    })
  );
}

boothOptionTemplateControllerCreateV1.PATH = '/api/v1/booth-option-template';
